module.exports = __webpack_public_path__ + "img/page智慧用电.a5a34ee3.png";